import React, { useEffect, useRef, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../../context/AlertContext";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import { useNetwork } from "../../../../../context/NetworkContext";
import AxiosInstance from "../../../../../utils/AxiosInstance";
import uRLs from "../../../../../utils/baseUtils";
import handleError from "../../../../../constants/handleError";
import { useAuth } from "../../../../../context/AuthProvider";
import { usePermission } from "../../../../../context/PermissionContext";
import CashButton from "../../../sale/cashbtn";
import PayLaterButton from "../../../sale/PaylaterBtn";
import QRCode from "qrcode";
import { formatCurrency } from "@heartinz/finance";
import {FormatedSaleData} from '../../../../../utils/print/GlobelSaleData';
import { capitalizeFirstLetter } from "../../../../../utils/print/a4Invoices/common/invoiceUtils";
import { DownloadIcon, PrinterIcon, ShowIcon } from "../../../../../constants/Icons";
const InvoiceThumnail8 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  downloadbtn = false,
  payment = false,
}) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { permission, blockedPermissions, storeSettings, viewOption } =
    usePermission();
  const { isUser,settings } = useAuth();
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [terms, setTerms] = useState([]);
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [error, setErrors] = useState({});
  const [isPaySettleModalOpen, setIsPaySettleModalOpen] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(true);
  const [data, setData] = useState({});
  const globalData=FormatedSaleData(data);
  const cashRef = useRef();
  const paylaterRef = useRef();

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };
    const formatCurrencyINR = (value) => {    
    const formatted = Math.abs(value).toLocaleString('en-IN', {
    minimumFractionDigits: 0, 
    maximumFractionDigits: 2  
  });   
    return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  // new template starts ////// **/////////////////////////////

  const urlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const joinAddress = (...lines) =>
    lines
      .map((l) => l?.trim())
      .filter(Boolean)
      .join(", ");
 const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
  //compact invoice
    const generateInvoice1 = async () => {
   const doc = new jsPDF("p", "mm", "a4");
   const pageW = doc.internal.pageSize.getWidth();
   const pageH = doc.internal.pageSize.getHeight();
   const PADDING = 5;
   const MARGIN_LEFT = PADDING;
   const MARGIN_RIGHT = pageW - PADDING;
   const centerX = pageW / 2;
   let y = PADDING ; // Starting height
    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
    
   if (imagePath) {
       try {
 
           const logoBase64 = await urlToBase64(imagePath);
           const { width, height } = await loadImageDimensions(logoBase64);
           // 1. DRAW LOGO (Far Left)
           const maxWidth = 30;
           const maxHeight = 12;
            const ratio = Math.min(maxWidth / width, maxHeight / height);
           const finalW = width * ratio;
           const finalH = height * ratio;
            
           doc.addImage(logoBase64, "PNG", MARGIN_LEFT, y, finalW, finalH);
           doc.setFont("Inter-Regular", "normal");
           doc.setFontSize(9);
           doc.setTextColor(0);
           doc.text("TAX INVOICE", centerX, y + 3, { align: "center" });
   
           doc.setFont("Inter-Bold", "bold");
           doc.setFontSize(11); 
           doc.setTextColor(0);
           doc.text(data.salefrom?.title?.toUpperCase() || "", centerX, y + 8, { align: "center" });
   
           doc.setFontSize(9);
           doc.setTextColor(0);
           
           // Invoice No Row     
           
         const invLabel = "Invoice No. ";
         const invVal = data.saleno || "-";      
         const invDateTime = DateConverter.ISOToDisplayFormat(
                DateConverter.convertToTimeZone(globalData?.saledate, isUser.timezone),
              ).time;
         const dateStr = `DATE: ${data.saledate ? DateConverter.ISOToDisplayFormat(globalData.saledate).date : "-"}  `;
         const timeStr = `TIME: ${invDateTime || ""}`;
         const invValW = doc.getTextWidth(invVal);
         doc.setFont("Inter-Regular", "normal");
         doc.text(invLabel, MARGIN_RIGHT - invValW - doc.getTextWidth(invLabel), y + 2);
         doc.setFont("Inter-Bold", "bold");
         doc.text(invVal, MARGIN_RIGHT, y + 2, { align: "right" });
         const totalDateTimeWidth = doc.getTextWidth(dateStr) + doc.getTextWidth(timeStr);
   
         const lineStartX = MARGIN_RIGHT - totalDateTimeWidth -1; // Adjust this number to make the line longer/shorter
         doc.setDrawColor(selectedTheme?.templateTheme?.borderColor); // Light grey color
         doc.setLineWidth(0.1);
         doc.line(lineStartX, y + 4, MARGIN_RIGHT, y + 4);    
         
           const timeStrW = doc.getTextWidth(timeStr);
           doc.setFont("Inter-Regular", "normal");
           doc.text(dateStr, MARGIN_RIGHT - timeStrW - 1, y + 8, { align: "right" });
           doc.text(timeStr, MARGIN_RIGHT, y + 8, { align: "right" });  
               
           let addrY = y + finalH+4; // Move down below logo/title area
           doc.setFont("Inter-Regular", "normal");
           doc.setFontSize(9);
          //  doc.setTextColor(60, 60, 60);
    let currentTextY = addrY;
           const addrLine1 = [globalData?.salefrom?.addressline1, globalData?.salefrom?.addressline2].filter(Boolean).join(", ");
           const addrLine2 = [globalData?.salefrom?.district, globalData?.salefrom?.state, globalData?.salefrom?.pincode].filter(Boolean).join(", ");
           
           const maxWidthAdd = 60; // Adjust this value based on your layout
           const wrappedAddress1 = doc.splitTextToSize(addrLine1, maxWidthAdd);
           const wrappedAddress2 = doc.splitTextToSize(addrLine2, maxWidthAdd);
           if (addrLine1.trim()) {
           doc.text(wrappedAddress1, MARGIN_LEFT, currentTextY); 
            currentTextY += (wrappedAddress1.length * 4);
    }   if (addrLine2.trim()) {  
           doc.text(wrappedAddress2, MARGIN_LEFT, currentTextY); 
            currentTextY += (wrappedAddress2.length * 4.5);
    }
           // const contactY = addrY + 6;
           let currentX = MARGIN_LEFT;
                const phone = globalData?.salefrom?.phone;
   const gstin = globalData?.salefrom?.gstnumber;
   
           if (phone || gstin) {
           doc.setFont("Inter-Bold", "bold");
           doc.text("Ph:", currentX, currentTextY);
           currentX += doc.getTextWidth("Ph: ");
   
           doc.setFont("Inter-Regular", "normal");
           doc.text(`${globalData?.salefrom?.phone || ""}  `, currentX, currentTextY);
           currentX += doc.getTextWidth(`${phone || ""}  `);
           
           doc.setFont("Inter-Bold", "bold");
           doc.text("GSTIN:", currentX, currentTextY);
           currentX += doc.getTextWidth("GSTIN: ");
   
           doc.setFont("Inter-Regular", "normal");
           doc.text(`${gstin || ""}`, currentX, currentTextY);
           // doc.text(contactLine, MARGIN_LEFT, addrY + 6);
           }
           y = currentTextY + 2; 
   
       } catch (e) {
           console.warn("Header layout failed", e);
           y += 15;
       }
   }
   
   
   y +=1;
    
   if (globalData?.saleto ) {
    const hasShipping = globalData?.saleto?.shippingAddress?.addressline1 || globalData?.saleto?.shippingAddress?.addressline2; // adjust key if needed
  
    let rowHeight = 6;
    doc.setDrawColor(selectedTheme?.templateTheme?.borderColor || [200, 200, 200]);
    doc.setLineWidth(0.2);
  
    const totalBoxWidth = MARGIN_RIGHT - MARGIN_LEFT;
    const col1EndX = hasShipping
      ? MARGIN_LEFT + totalBoxWidth * 0.39
      : MARGIN_LEFT + totalBoxWidth * 0.75;
    const col2EndX = MARGIN_LEFT + totalBoxWidth * 0.76;
    const rightSectionStart = col2EndX + 2;
  
    // --- LEFT: Customer Details ---
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    doc.text("Customer Details :", MARGIN_LEFT + 2, y + 4);
  
    doc.setFontSize(8);
    doc.setFont("Inter-Regular", "normal");
    doc.text(globalData?.saleto?.name || "", MARGIN_LEFT + 2, y + 8);
    rowHeight += 4;
  
    const fullAddress = [
      globalData?.saleto?.addressline1,
      globalData?.saleto?.addressline2,
      globalData?.saleto?.district,
      globalData?.saleto?.state,
    ].filter(Boolean).join(", ");
    const pinCode = globalData?.saleto?.pincode ? ` - ${globalData?.saleto.pincode}` : "";
  
    const col1MaxWidth = col1EndX - MARGIN_LEFT - 4;
    if (fullAddress || pinCode) {
      doc.setFontSize(9);
      const wrappedAddr = doc.splitTextToSize(fullAddress + pinCode, col1MaxWidth);
      doc.text(wrappedAddr, MARGIN_LEFT + 2, y + 12);
      rowHeight += wrappedAddr.length * 3.5;
    }
  
    // --- MIDDLE: Shipping Details ---
    let shippingRowHeight = 6;
    if (hasShipping) {
      const shipping = globalData.saleto?.shippingAddress;
      const col2StartX = col1EndX + 2;
      const col2MaxWidth = col2EndX - col1EndX - 4;
  
      doc.setFont("Inter-Bold", "bold");
      doc.setFontSize(9);
      doc.text("Shipping Details :", col2StartX, y + 4);
  
      doc.setFontSize(8);
      doc.setFont("Inter-Regular", "normal");
      const shipAddress = [
        shipping?.addressline1,
        shipping?.addressline2,
        shipping?.district,
        shipping?.state,
      ].filter(Boolean).join(", ");
      const shipPin = shipping?.pincode ? ` - ${shipping.pincode}` : "";
  
      if (shipAddress || shipPin) {
        doc.setFontSize(9);
        const wrappedShip = doc.splitTextToSize(shipAddress + shipPin, col2MaxWidth);
        doc.text(wrappedShip, col2StartX, y + 8);
        shippingRowHeight += wrappedShip.length * 3.5;
      }
  
      rowHeight = Math.max(rowHeight, shippingRowHeight);
    }
  
    // --- RIGHT: Ph / GSTIN ---
    doc.setFont("Inter-Bold", "bold");
    doc.setFontSize(9);
    const phLabel = "Ph: ";
    doc.text(phLabel, rightSectionStart, y + 4);
    doc.setFont("Inter-Regular", "normal");
    doc.text(globalData?.saleto?.phone || "", rightSectionStart + doc.getTextWidth(phLabel), y + 4);
  
    doc.setFont("Inter-Bold", "bold");
    const gstLabel = "GSTIN: ";
    doc.text(gstLabel, rightSectionStart, y + 9);
    doc.setFont("Inter-Regular", "normal");
    doc.text(globalData?.saleto?.gstnumber || "", rightSectionStart + doc.getTextWidth(gstLabel), y + 9);
  
    // Draw dividers
    doc.line(col1EndX, y, col1EndX, y + rowHeight);
    if (hasShipping) {
      doc.line(col2EndX, y, col2EndX, y + rowHeight);
    }
  
    doc.rect(MARGIN_LEFT, y, MARGIN_RIGHT - MARGIN_LEFT, rowHeight);
    y += rowHeight;
  }
       /* -------------------------------------------------
        PRODUCT TABLE1
     ------------------------------------------------- */
     const rowCount = globalData?.saleitems?.length;
   
    const standardHeight = 4;
   const targetTotalHeight = 40;
   const extraSpace = (rowCount > 0 && rowCount <= 5) 
       ? (targetTotalHeight - (rowCount * standardHeight)) 
       : 0;
   autoTable(doc, {
     startY: y,
     theme: "plain",
     rowPageBreak: 'avoid',
     margin: { 
       top: PADDING, 
       left: PADDING, 
       right: PADDING,  
       bottom: PADDING 
     },
     styles: {
       font: "Inter-Regular",
       fontSize: 9,
       cellPadding:1.5,
       valign: "top",
       lineWidth: 0, // No default borders
       
     },
     headStyles: {
       font: "Inter-Bold",
      //  fontSize: 7,
       fillColor: selectedTheme?.templateTheme?.primaryColor || [216, 27, 96], // Pink like image
         textColor: selectedTheme?.templateTheme?.foregroundColor,
       lineWidth: 0.2,
       lineColor:(selectedTheme?.templateTheme?.borderColor || [200, 200, 200]) 
     },
     bodyStyles: {
       minCellHeight: Math.max(2, standardHeight), 
     },
     head: [["#", "Item",  "Rate", "Qty","Taxable Val","Tax Amt" ,"Amount"]],
     body: globalData?.saleitems.map((it, i) => [
       i + 1,
       it.hsnsac ? `${it.title}\n${it.imode === "SERVICE" ? "SAC:" : "HSN:"} ${it.hsnsac}` : it.title,
       
       `₹${it.baseprice}`,
       `${it.quantity} ${
        (() => {
          const unitCode = it?.isSecondaryUnit
            ? (it?.unitConfig?.secondaryUnitCode ||"")
            : (it?.unitConfig?.primaryUnitCode || "");
          return unitCode||"" ;
        })()
      }`,
       `₹${it.lineTotalBasePrice}`,
       `₹${it.lineTotalTaxAmount}`,
       
       `₹${it.lineGrandTotal}`,
     ]),
       columnStyles: {
       0: { cellWidth: 10, halign: "center" },
       1: { cellWidth: "auto", halign: "left" },       
       2: { cellWidth: 20, halign: "right" },
       3: { cellWidth: 11, halign: "center" },
       4: { cellWidth: 22, halign: "right" },
       5: { cellWidth: 20, halign: "right" },
       6: { cellWidth: 22, halign: "right" },
     },
     didParseCell: function (data) {
       if (data.section === "head") {  
      
               const colId = data.column.index;
             if (colId === 0 || colId === 3) data.cell.styles.halign = "center";
             if (colId === 2 || colId === 4  || colId === 5 || colId === 6)
               data.cell.styles.halign = "right";
           }
       if (data.section === "body") {
         data.cell.styles.lineWidth = {
           left: 0.1, 
           right: 0.1, 
           top: 0,
           bottom: 0   
         };
         data.cell.styles.lineColor =(selectedTheme?.templateTheme?.borderColor || [200, 200, 200]) ; // Black vertical lines
      if (data.row.index === rowCount - 1 ) {        
           data.cell.styles.minCellHeight = standardHeight + extraSpace;
         }
         if (data.row.index === rowCount - 1) {        
           data.cell.styles.lineWidth.bottom = 0.1;
         }
       }
     },
       didDrawPage: function (data) {
        const finalY = data.cursor.y;
        doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);
        doc.line(PADDING, finalY, pageW - PADDING, finalY); // Bottom horizontal line
     }   
   });
    let finalY = doc.lastAutoTable.finalY;
const footerHeight = 45; // Increased to accommodate the stacked boxes

if (finalY + footerHeight > pageH - PADDING) {
  doc.addPage();
  finalY = PADDING;
}

const borderColor = selectedTheme?.templateTheme?.borderColor || [200, 200, 200];
doc.setDrawColor(borderColor[0], borderColor[1], borderColor[2]);
doc.setLineWidth(0.1);

// X-coordinate for the vertical divider (aligns with the last column)
const dividerX = MARGIN_RIGHT - 64; 
const boxWidth = MARGIN_RIGHT - PADDING;
const isInterState = globalData?.salefrom?.statecode && 
                     globalData?.saleto?.statecode && 
                     globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;
    
// --- BOX 1: TOTALS AND TAXES ---
const box1Height = isInterState? 12:18;
doc.rect(PADDING, finalY, boxWidth, box1Height); // Outer border
doc.line(dividerX, finalY, dividerX, finalY + box1Height); // Vertical divider

// Box 1 Content: In Words
doc.setFont("Inter-Bold", "bold");
doc.setFontSize(9);
doc.text("In Words:", PADDING + 2, finalY + 5);
doc.setFont("Inter-Regular", "normal");
const words = isViewData?.amountinwords || "";
doc.text(words, PADDING + 15, finalY + 5, { maxWidth: dividerX - PADDING - 17 });


  const taxSummary = [
    { label: "TOTAL", value: globalData?.grandtotal },

    ...(isInterState
      ? [{ label: "IGST", value: globalData?.igstamount || 0 }]
      : [
          { label: "CGST", value: globalData?.cgstamount || 0 },
          { label: "SGST", value: globalData?.sgstamount || 0 }
        ])
  ];

  taxSummary.forEach((item, i) => {
    let itemY = finalY + 4 + (i * 6);
    doc.text(item.label, dividerX + 2, itemY);
    doc.text(`₹${item.value}`, MARGIN_RIGHT - 2, itemY, { align: "right" });
    if (i < taxSummary.length - 1) {
      doc.line(dividerX, itemY + 2, MARGIN_RIGHT, itemY + 2); // Mini horizontal lines
    }
  });
  const paymentData = [
    { label: "Cash", val: globalData?.cashPaid },
    { label: "Card", val: globalData?.cardPaid },
    { label: "UPI", val: globalData?.upiPaid },
    { label: "Online", val: globalData?.onlinePaid }
  ].filter(p => p.val > 0);

  // --- BOX 2: PAYMENTS AND PAYABLES ---
  const box2Y = finalY + box1Height;
  const box2Height = 12;
  doc.rect(PADDING, box2Y, boxWidth, box2Height); // Outer border
  doc.line(dividerX, box2Y, dividerX, box2Y + box2Height); // Vertical divider

  // Box 2 Content: Payment Methods (Left Side)
  let payX = PADDING + 2;

    paymentData.forEach((pay, index) => {
    const col = index % 2;              // 0 or 1 (2 per row)
    const row = Math.floor(index / 2); // row number
  const colWidth =50; // horizontal spacing
  const rowHeight = 5;
    const x = payX + (col * colWidth);
    const y = box2Y + 4 + (row * rowHeight);
    const displayVal = `₹${pay.val}`;
    doc.setFont("Inter-Bold", "bold");
    doc.text(displayVal, x, y);
    
const valWidth = doc.getTextWidth(displayVal);
    doc.setFont("Inter-Regular", "normal");
    doc.text(` Paid via ${pay.label}`, x + valWidth + 1, y);
  });
     const paidamount = (globalData?.grandtotal || 0) - (globalData?.balanceDue || 0);

  // Box 2 Content: Payables (Right Side)
  const payableSummary = [
    { label: "Amount Payable", value: globalData?.balanceDue, isBold: true },
    { label: "Amount Paid", value: `${paidamount.toFixed(2)}`, isBold: false }
  ];
  payableSummary.forEach((item, i) => {
      let itemY = box2Y + 4 + (i * 6);

      if (i === 0) {
          const themeColor = selectedTheme?.templateTheme?.primaryColor || [216, 27, 96];
         
          doc.setFillColor(themeColor);       
          doc.rect(dividerX + 0.5, itemY - 4, (MARGIN_RIGHT - dividerX) - 1, 6, 'F');
          // Draw the bottom separator line
           doc.setDrawColor(selectedTheme?.templateTheme?.borderColor);  
          doc.line(dividerX, itemY - 4, MARGIN_RIGHT, itemY - 4);
          doc.line(dividerX, itemY + 2, MARGIN_RIGHT, itemY + 2);          
      }  
      const textColor=selectedTheme?.templateTheme?.foregroundColor;  
       if (item.isBold) {
      doc.setTextColor(textColor); 
      doc.setFont("Inter-Bold", "bold");
    } else {
      doc.setTextColor(0, 0, 0); // black
      doc.setFont("Inter-Regular", "normal");
    }
      doc.text(item.label, dividerX + 2, itemY);
      doc.text(`₹${item.value}`, MARGIN_RIGHT - 2, itemY, { align: "right" });
  });
let signatureY = box2Y + 4 + (payableSummary.length * 6) ;
doc.setFont("Inter-Bold", "bold");
doc.setFontSize(8);
doc.text(`For ${globalData?.salefrom?.title}`, pageW - PADDING , signatureY+1 , { align: "right" });
if (storeSettings?.invoiceSettings?.signature) {
  try {
    const signimg = uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
    const base64 = await urlToBase64(signimg);
    const { width, height } = await loadImageDimensions(base64);

    const maxWidth = 25;
    const maxHeight = 10;
    const ratio = Math.min(maxWidth / width, maxHeight / height);
    const imgW = width * ratio;
    const imgH = height * ratio;
signatureY+=4;
    doc.addImage(
      base64,
      signimg.endsWith(".png") ? "PNG" : "JPEG",
      MARGIN_RIGHT - imgW+2,
      signatureY,
      imgW,
      imgH
    );

  } catch {
    console.warn("Signature load failed");
  }
} else {
    signatureY+=10;
      doc.setDrawColor(borderColor);
  doc.line(pageW - PADDING - 30, signatureY , pageW - PADDING, signatureY );
}

//  Label
doc.setFont("Inter-Regular", "normal");
doc.setFontSize(8);
if (storeSettings?.invoiceSettings?.signature) {
  signatureY+= 9;
}else{
  signatureY+= 4;
}
doc.text("Authorized Signatory", MARGIN_RIGHT, signatureY , { align: "right" });
 //  Row 2 (Terms)
let termsStartY = signatureY + 8;

if (terms?.length > 0) {
  if (termsStartY > pageH - 25) {
    doc.addPage();
    termsStartY = PADDING;
  }

  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(9);
  doc.text("Terms & Conditions", PADDING, termsStartY);

  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(9);

  const termLines = doc.splitTextToSize(terms, pageW - PADDING * 2);

  let currentY = termsStartY + 5;

  termLines.forEach((line) => {
    if (currentY > pageH - 20) {
      doc.addPage();
      currentY = PADDING;
    }
    doc.text(line, PADDING, currentY);
    currentY += 5;
  });

  termsStartY = currentY; // update for next section
}

   //  Row 3 (Branding)
if (storeSettings?.negobillBranding) {
  let brandingY = termsStartY + 6;

  const normalText = "Powered by ";
  const boldText = "NegoBill.com";

  doc.setFontSize(10);

  doc.setFont("Inter-Regular", "normal");
  const normalW = doc.getTextWidth(normalText);
  doc.text(normalText, MARGIN_LEFT, brandingY);

  doc.setFont("Inter-Bold", "bold");
  doc.text(boldText, MARGIN_LEFT + normalW, brandingY);
}
      
       return doc;
     };



  //A4 bill commercial

 const generateBill1 = async () => {
    const doc = new jsPDF("p", "mm", "a4");

    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    const PADDING = 5;
    let boxStartY = 10;

    const MARGIN_LEFT = PADDING;
    const MARGIN_RIGHT = pageW - PADDING;

    // ===== TITLE =====
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("BILL RECEIPT", pageW / 2, 8, { align: "center" });

    // Define column split points
    const col1 = PADDING + 80;
    const col2 = PADDING + 145; // Slightly adjusted for better spacing

    // Initialize Y trackers for each column
    let leftY = boxStartY + 4;
    let centerY = boxStartY + 4;
    let rightY = boxStartY + 4;

    // ==============================
    // LEFT SECTION (Company)
    // ==============================
       const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";
    if (imagePath) {
      try {
       
        const base64 = await urlToBase64(imagePath);
        const { width, height } = await loadImageDimensions(base64);
        const maxWidth = 20;
        const maxHeight = 15;
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        const finalWidth = width * ratio;
        const finalHeight = height * ratio;
        // Use leftY as reference
        doc.addImage(
          base64,
          "PNG",
          MARGIN_LEFT + 2,
          leftY - 2,
          finalWidth,
          finalHeight,
        );
      } catch {
        doc.text("LOGO", MARGIN_LEFT + 2, leftY + 5);
      }
    }

    const leftX = 30;
    const availableWidth = col1 - (MARGIN_LEFT + leftX) - 2;
    doc.setFontSize(8);
    doc.setFont("Inter-Bold", "bold");
    const companyTitleLines = doc.splitTextToSize(
      globalData?.salefrom?.title || "",
      availableWidth,
    );

    companyTitleLines.forEach((line) => {
      doc.text(line, MARGIN_LEFT + leftX, leftY);
      leftY += 3.5;
    });
  

    const fromAddress = joinAddress(
      globalData?.salefrom?.addressline1,
      globalData?.salefrom?.addressline2,
      globalData?.salefrom?.district,
      globalData?.salefrom?.state,
      globalData?.salefrom?.pincode,
    );
    doc.setFont("Inter-Regular", "normal");
    // leftY += 4;
    const fromAddrLines = doc.splitTextToSize(fromAddress, 50); // Wrapped size
    doc.text(fromAddrLines, MARGIN_LEFT + leftX, leftY);
    leftY += fromAddrLines.length * 4;
    leftY -= 1;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Mobile", MARGIN_LEFT + leftX, leftY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      `${globalData?.salefrom?.phone || ""}`,
      MARGIN_LEFT + leftX + 10,
      leftY,
    );

    leftY += 3;

    // Email
    doc.setFont("Inter-Bold", "bold");
    doc.text("Email", MARGIN_LEFT + leftX, leftY);

    doc.setFont("Inter-Regular", "normal");
    doc.text(
      `${globalData?.salefrom?.email || ""}`,
      MARGIN_LEFT + leftX + 8,
      leftY,
    );

    // ==============================
    // CENTER SECTION (Customer)
    // ==============================
    let centerX = col1 + 2;
    let centerValueX = col2 - 2;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill To", centerX, centerY);
    centerY += 4;
    doc.setFont("Inter-Regular", "normal");

    const name = globalData?.saleto?.name || "";
    const nameWidth = col2 - centerX - 4;
    const nameLines = doc.splitTextToSize(name, nameWidth);
    if (name) {
      nameLines.forEach((line) => {
        doc.text(line, centerX, centerY);
        centerY += 3.5;
      });
    }
    //  doc.text(globalData?.saleto?.name || "", centerX, centerY);
    //  centerY += 3;
    doc.setFont("Inter-Regular", "normal");
    const custAddress = [
      globalData?.saleto?.addressline1,
      globalData?.saleto?.addressline2,
      globalData?.saleto?.district,
      globalData?.saleto?.state,
      globalData?.saleto?.pincode,
    ]
      .filter(Boolean)
      .join(", ");

    // if (custAddress) {
    //   centerY += 4;
    // } else {
    //   centerY += 2;
    // }

    const custAddrLines = doc.splitTextToSize(custAddress, 55);
    doc.text(custAddrLines, centerX, centerY);
    centerY += custAddrLines.length * 4;
    centerY -= 1;
    const contactInfo = `Ph: ${globalData?.saleto?.phone || ""} `;
    doc.text(contactInfo, centerX, centerY);
    if (globalData?.saleto?.gstnumber) {
      centerY += 4;
      doc.text(`Email ${globalData?.saleto?.email || ""}`, centerX, centerY);
    }
    centerY += 4;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Place of Supply:", centerX, centerY);
    doc.setFont("Inter-Bold", "bold");
    doc.text(globalData?.saleto?.state || "", centerValueX, centerY, {
      align: "right",
    });
    //  centerY += 4;
    //  doc.text("Bill To:", centerX, centerY);

    // ==============================
    // RIGHT SECTION (Invoice Info) - ALIGNED RIGHT
    // ==============================
    let labelX = col2 + 2;
    let valueX = pageW - PADDING - 2; // The rightmost edge

    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill #:", labelX, rightY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(globalData?.saleno || "", valueX, rightY, { align: "right" });

    rightY += 4;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill Date:", labelX, rightY);
    doc.setFont("Inter-Regular", "normal");
    doc.text(
      DateConverter.ISOToDisplayFormat(globalData?.saledate).date || "",
      valueX,
      rightY,
      { align: "right" },
    );

    rightY += 4;
    doc.setFont("Inter-Bold", "bold");
    doc.text("Bill Time:", labelX, rightY);
    const invDateTime = DateConverter.ISOToDisplayFormat(
      DateConverter.convertToTimeZone(globalData?.saledate, isUser.timezone),
    ).time;
    doc.setFont("Inter-Regular", "normal");
    doc.text(invDateTime || "", valueX, rightY, { align: "right" });
    const headerBottomY = Math.max(leftY, centerY, rightY) + 3;
    doc.line(col1, boxStartY, col1, headerBottomY);
    doc.line(col2, boxStartY, col2, headerBottomY);
    doc.line(PADDING, headerBottomY, pageW - PADDING, headerBottomY);

    autoTable(doc, {
      startY: headerBottomY,
      theme: "grid",
      margin: { left: PADDING, right: PADDING, top: PADDING, bottom: PADDING },
      styles: {
        font: "Inter-Regular",
        fontStyle: "normal",
        fontSize: 8,
        cellPadding: { top: 1, bottom: 1, left: 2, right: 2 },
        textColor: "#041121",
        lineColor: [200, 200, 200],
        lineWidth: 0.1,
      },
      headStyles: {
        font: "Inter-Bold",
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        lineWidth: { top: 0, bottom: 0.5, left: 0.1, right: 0.1 },
      },
      columnStyles: {
        0: { cellWidth: 12 },
        1: { cellWidth: "auto" },
        2: { cellWidth: 20, halign: "right" },
        3: { cellWidth: 25, halign: "right" },
        4: { cellWidth: 25, halign: "right" },
        5: { cellWidth: 15, halign: "right" },
       
        6: { cellWidth: 20, halign: "right" },
      },
      head: [
        [
          "#",
          "Item",
          "HSN/SAC",
          "Price",
           "MRP",
          "Qty",         
          "Amount",
        ],
      ],      
      body: globalData.saleitems.map((it, i) => [
        i + 1,
        { content: `${it.title}\n${it.note || ""}` },

        it.hsnsac,
        `₹${it.baseprice}`,
         `₹${it.mrp}`,
        it.quantity,
       
        `₹${it.lineGrandTotal}`,       
      ]),
      didParseCell: function (globalData) {
        globalData.cell.styles.lineColor = [200, 200, 200];

        if (globalData.section === "head") {
          const colId = globalData.column.index;
          if (colId === 0) globalData.cell.styles.halign = "left";
          if ([2, 3, 4, 5, 6, 7].includes(colId))
            globalData.cell.styles.halign = "right";

          globalData.cell.styles.lineWidth = {
            top: 0,
            bottom: 0,
            left: 0.1,
            right: 0.1,
          };
        }

        if (globalData.section === "body") {
          const isLastRow =
            globalData.row.index === globalData.table.body.length - 1;
          globalData.cell.styles.lineWidth = {
            top: 0,
            bottom: isLastRow ? 0.5 : 0,
            left: 0.1,
            right: 0.1,
          };
        }
      },

      didDrawCell: function (globalData) {
        const pageW = doc.internal.pageSize.getWidth();
        const pageH = doc.internal.pageSize.getHeight();
        const pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
        // Draw outer box for each page
        doc.setDrawColor(0);
        doc.setLineWidth(0.1);
        doc.rect(
          PADDING,
          boxStartY,
          pageW - PADDING * 2,
          pageH - boxStartY - PADDING,
        );
        if (pageNumber === 1) {
          // first page
          doc.line(PADDING, headerBottomY, pageW - PADDING, headerBottomY);
        } else {
          boxStartY = PADDING;
        }
        if (globalData.section === "head") {
          globalData.doc.setDrawColor(0, 0, 0);
          globalData.doc.setLineWidth(1);
          globalData.doc.line(
            globalData.cell.x,
            globalData.cell.y + globalData.cell.height,
            globalData.cell.x + globalData.cell.width,
            globalData.cell.y + globalData.cell.height,
          );
        }
      },
    });

    doc.setDrawColor(0);
    doc.setLineWidth(0.1);
    // doc.rect(PADDING, boxStartY, pageW - (PADDING * 2), finalTableY - boxStartY);// below table
    const summaryText = `Total amount (in words):`;
    const amountWords = `${globalData?.amountinwords || ""}`;
    const bankInfo = [
      [
        "Name:",
        storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "",
      ],
      [
        "Account #:",
        storeSettings?.paymentSettings?.bankDetails?.accountNo || "",
      ],
      ["IFSC:", storeSettings?.paymentSettings?.bankDetails?.ifsc || ""],
      [
        "Branch:",
        storeSettings?.paymentSettings?.bankDetails?.branchName || "",
      ],
    ];
    let summaryY = doc.lastAutoTable.finalY;
    const bankRows = storeSettings?.paymentSettings?.bankDetails
      ? bankInfo.length
      : 0;

    const summaryHeight =
      5 + // top gap
      4 + // amount words
      6 + // spacing
      bankRows * 4 + // bank rows
      8 + // UPI
      35; // QR + summary table safety

    if (summaryY + summaryHeight > pageH - PADDING) {
      doc.addPage();
      summaryY = PADDING; // New top position
      boxStartY = summaryY; // <--- ADD THIS LINE: Resets the rectangle anchor
    }
    doc.setFontSize(8);
    doc.setFont("Inter-Bold", "bold");
    let footerY = summaryY + 5;
    doc.text(summaryText, PADDING + 2, footerY);
    footerY += 4;
    doc.setFont("Inter-Regular", "normal");
    doc.text(amountWords, PADDING + 2, footerY);

    footerY += 6;
    doc.setFont("Inter-Bold", "bold");
    if (storeSettings?.paymentSettings?.bankDetails) {
      doc.text("Bank Details:", PADDING + 2, footerY);
      doc.setFont("Inter-Regular", "normal");
      footerY += 4;
      bankInfo.forEach(([label, value]) => {
        doc.setFont("Inter-Regular", "normal");
        doc.text(label, PADDING + 2, footerY);
        doc.setFont("Inter-Bold", "bold");
        doc.text(String(value || ""), PADDING + 20, footerY);
        footerY += 4;
        // doc.text(`${label} ${value}`, PADDING + 2, footerY);
      });
    }
    const upiId = storeSettings?.paymentSettings?.upiId || "";
    doc.setFontSize(8);
    footerY += 3;
    if (upiId) {
      doc.text(`UPI ID: ${upiId}`, PADDING + 2, footerY, { align: "left" });
    }
    // 4. QR Code Section (Center)
    const QRSIZE = 30;
    if (upiId && upiId.trim() !== "") {
      const upiUrl = `upi://pay?pa=${upiId}&pn=${encodeURIComponent(storeSettings?.paymentSettings?.bankDetails?.beneficiaryName || "")}&cu=INR`;
      const qrX = pageW / 2 - 10;
      const qrCodeDataUrl = await QRCode.toDataURL(upiUrl, {
        errorCorrectionLevel: "L",
        scale: 4,
        margin: 1,
      });
      doc.addImage(qrCodeDataUrl, "JPEG", qrX, summaryY + 10, QRSIZE, QRSIZE);
    }

    // 5. Right Side: Financial Summary (Taxable, Tax, Total)
    const finalSummaryX = col2 - 20; // Align with the right-most vertical line
    let rightSummaryY = summaryY;
const summaryWidth = pageW - PADDING - finalSummaryX;
const rowHeight = 6;

const rows = [
  ["Total", `₹${globalData?.grandtotal}`],
  ["Amount Payable", `₹${globalData?.balanceDue}`],
  ["Amount Paid", `₹${globalData?.paidamount}`],
];

const tableHeight = rows.length * rowHeight;
  doc.setFont("Inter-Regular", "normal");
   doc.setFontSize(9);
   // Top line
doc.line(finalSummaryX, rightSummaryY, finalSummaryX + summaryWidth, rightSummaryY);

// Left line
doc.line(finalSummaryX, rightSummaryY, finalSummaryX, rightSummaryY + tableHeight);

// Right line
doc.line(finalSummaryX + summaryWidth, rightSummaryY, finalSummaryX + summaryWidth, rightSummaryY + tableHeight);
  let y = rightSummaryY;
 
    rows.forEach((row, i) => {
        const textY = y + rowHeight / 2 + 1.5;     
        if (row[0] === "Amount Paid") {        
            doc.setFont("Inter-Bold", "bold");
            // doc.setTextColor(40, 167, 69);       
            
            const centeredText = `${row[0]} : ${row[1]}`;        
          const boxCenterX = finalSummaryX + (summaryWidth / 2);
            doc.text(centeredText, boxCenterX, textY, { align: "center" });        
            doc.setTextColor(0, 0, 0);

        } else {     
            if (row[0] === "Amount Payable") {
                doc.setFont("Inter-Bold", "bold");
            } else {
                doc.setFont("Inter-Regular", "normal");
            }        
            doc.setTextColor(0, 0, 0);
            doc.text(row[0], finalSummaryX + 2, textY, { align: "left" });  
            doc.text(row[1], finalSummaryX + summaryWidth - 2, textY, { align: "right" });
        }
        if (i !== rows.length - 1) {
            doc.line(finalSummaryX, y + rowHeight, finalSummaryX + summaryWidth, y + rowHeight);
        }

        y += rowHeight;
    });
    doc.setFont("Inter-Regular", "normal");
    const finalFooterY = Math.max(footerY, doc.lastAutoTable.finalY) + 5;
    doc.setDrawColor(0);
    doc.setTextColor(0,0,0);
    // doc.setLineWidth(0.5);
    doc.rect(PADDING, boxStartY, pageW - PADDING * 2, finalFooterY - boxStartY);
    doc.line(PADDING, summaryY, pageW - PADDING, summaryY);
    doc.line(finalSummaryX, rightSummaryY, finalSummaryX, finalFooterY);

    // // 6. BOTTOM SECTION: 3 Sections (Notes | Terms | Signature)
   const rawTerms = terms || "";
   const footerWidth = pageW  * PADDING;
   const termLines = doc.splitTextToSize(rawTerms, footerWidth ); 
   const termsHeight = termLines.length * 3.5 + 10; 
   const sigSectionHeight = 30; 
   let currentY = finalFooterY;
   if (currentY + termsHeight + sigSectionHeight > pageH - PADDING) {
      doc.addPage();
      currentY = PADDING;
   }
 
  doc.setFont("Inter-Bold", "bold");
  doc.setFontSize(8);
  doc.text("Terms and Conditions:", PADDING + 2, currentY + 5);
  doc.setFont("Inter-Regular", "normal");
  doc.setFontSize(7);
  termLines.forEach((line, i) => {
      doc.text(line, PADDING + 2, currentY + 10 + i * 3.5);
  });
  currentY += termsHeight;
  doc.setLineWidth(0.1);
  doc.line(PADDING, currentY, pageW - PADDING, currentY);  
  doc.setFontSize(7);
const totalFinalY = currentY + sigSectionHeight;
doc.setDrawColor(0);
doc.setLineWidth(0.1);
doc.rect(PADDING, currentY,pageW - PADDING * 2, sigSectionHeight-8);
const sigLineY = currentY + sigSectionHeight - 15; 
doc.line(PADDING + 2, sigLineY, PADDING + 35, sigLineY);
doc.setFont("Inter-Regular", "normal");
doc.setFontSize(7);
doc.text("Receiver's Signature", PADDING + 2, sigLineY + 4);
doc.setFont("Inter-Bold", "bold");
doc.setFontSize(7);
doc.text(`For ${globalData?.salefrom?.title}`, pageW - PADDING - 2, currentY + 5, { align: "right" });
if (storeSettings?.invoiceSettings?.signature) {
    try {
        const signimg = uRLs.IMAGE_URL + storeSettings.invoiceSettings.signature;
        const base64 = await urlToBase64(signimg);
        const { width, height } = await loadImageDimensions(base64);
       const maxWidth = 25; // Adjusted for smaller box
        const maxHeight = 10;
         const ratio = Math.min(maxWidth / width, maxHeight / height);
        const imgW = width * ratio;
        const imgH = height * ratio;
        doc.addImage(base64, "PNG", pageW - PADDING - imgW , sigLineY - imgH , imgW, imgH);
    } catch (e) {     
        doc.line(pageW - PADDING - 40, sigLineY, pageW - PADDING - 2, sigLineY);
    }
} else {   
    doc.line(pageW - PADDING - 45, sigLineY, pageW - PADDING - 2, sigLineY);
}
doc.text("Authorized Signatory", pageW - PADDING - 2, sigLineY + 4, { align: "right" });
if (storeSettings?.negobillBranding) {
    const brandingY = totalFinalY - 3;
    doc.setFontSize(8);
    const normalText = "Powered By ";
    const boldText = "NegoBill.com";
    const normalWidth = doc.getTextWidth(normalText);
    const boldWidth = doc.getTextWidth(boldText);
    const startX = (pageW - (normalWidth + boldWidth)) / 2;

    doc.setFont("Inter-Regular", "normal");
    doc.text(normalText, startX, brandingY);
    doc.setFont("Inter-Bold", "bold");
    doc.text(boldText, startX + normalWidth, brandingY);
}
    doc.setLineWidth(0.5);
    setDownload(false);

    return doc;
  };

  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generateBill1();
    } else {
      doc = await generateInvoice1();
    }

    const filenamePrefix = formatTrackMode(salemode)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  const handlePrint = async (data, overrideSize = null) => {
    setPrint(true);
    try {
      if (!checkNetwork()) return;

      const paperSize = overrideSize || selectedSize;
      const upperMode = data?.salemode?.toUpperCase();
      let doc;

      if (paperSize === "BILL") {
        doc = await generateBill1();
      } else {
        doc = await generateInvoice1();
      }

      const blob = doc.output("blob");
      const blobUrl = URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "none";
      iframe.src = blobUrl;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        const printWindow = iframe.contentWindow;

        const cleanup = () => {
          // Remove iframe safely
          if (iframe && iframe.parentNode) {
            iframe.parentNode.removeChild(iframe);
          }

          // Remove listeners
          window.removeEventListener("afterprint", cleanup);
          printWindow.matchMedia("(print)").removeListener(handlePrintState);
        };

        const handlePrintState = (mql) => {
          // WHEN PRINT PREVIEW CLOSES (printed OR canceled)
          if (!mql.matches) {
            setTimeout(cleanup, 50); // small delay makes Chrome stable
          }
        };

        // Watch print state
        printWindow.matchMedia("(print)").addListener(handlePrintState);

        // Also catch Chrome's afterprint
        window.addEventListener("afterprint", cleanup);
        setPrint(false);
        setTimeout(() => {
          if (window.bootstrap && window.bootstrap.Dropdown) {
            const dropdownElementList = [].slice.call(
              document.querySelectorAll(".dropdown-toggle")
            );
            dropdownElementList.map(function (dropdownToggleEl) {
              return new window.bootstrap.Dropdown(dropdownToggleEl);
            });
          }
        }, 100);
        // Trigger printing
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
        }, 300);
      };
    } catch (error) {
      setPrint(false);
      handleError(error, showAlert);
      return false;
    }
    // finally {
    //   setPrint(false);
    // }
  };

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

 
   const formatCurrency2 = (value) => {
     const amount = CurrencyConverter.toCurrency(value, "INR");
     const formatted = Math.abs(amount).toLocaleString('en-IN', {
     minimumFractionDigits: 0, // Don't force .00
     maximumFractionDigits: 2  // Show up to 2 decimals if they exist (like .78)
   }); 
   
     return value < 0 ? `-₹${formatted}` : `₹${formatted}`;
   };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(data);
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);
 const grantotal = CurrencyConverter.toCurrency(globalData?.grandtotal || 0, "INR");
      const paidamount = CurrencyConverter.toCurrency(
        globalData?.paidamount || 0,
        "INR",
      );
      const balanceDue = grantotal-paidamount 
       useEffect(() => {
          const upi = storeSettings?.paymentSettings?.upiId;
      
          const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
          if (!upi) return; // skip until upi is available
      
          const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
          console.log("ip",upiUrl)
          QRCode.toDataURL(upiUrl)
            .then((url) => {
              setQrCodeDataUrl(url);
            })
            .catch((err) => {
              console.error("QR Code generation failed: ", err);
            });
        }, [storeSettings?.paymentSettings?.upiId, storeSettings?.paymentSettings?.bankDetails?.beneficiaryName]);
       const isInterState = globalData?.salefrom?.statecode && 
                     globalData?.saleto?.statecode && 
                     globalData?.salefrom?.statecode !== globalData?.saleto?.statecode;
     const actualPaidAmount=globalData?.grandtotal  - globalData?.balanceDue;

  return (
    <>
      <div className="invoice-scale">
         {selectedSize === "INVOICE" ? (
              <div className="tm_container">
                <div className="tm_invoice_wrap">
                  <div className="tm_invoice tm_style1 tm_type1">
                    <div className="tm_invoice_in p-3" >
                      <div className="d-flex pb-1" >
                        <div style={{ flex: "1",  }}>
                          <div>
                             {globalData?.salefrom?.image && (  
                        <img
                                                          src={
                                                            settings?.saleProfileData?.image
                                                               ? uRLs.IMAGE_URL +
                                                                 "profile/" + settings?.saleProfileData?.image : "/assets/images/logo-light.png"
                                                            }
                                               className="img-rounded logo mb-0"
                                               height="45"
                                               width="100"
                                               style={{ objectFit: "contain" }}
                                             />
                                                        )}
                          </div>
                          
                          <div className="font-14">{globalData?.salefrom?.addressline1}{" "}{globalData?.salefrom?.addressline2}</div>
                          <div className="font-14"> {globalData?.salefrom?.district}{" "}{globalData?.salefrom?.state}{" "}{globalData?.salefrom?.pincode }</div>
                          <div className="font-13"><span className="fw-bold">Ph:</span>{" "}{settings?.saleProfileData?.phone} {" "} <span className="fw-bold">GSTIN:</span>{" "}{settings?.saleProfileData?.gstnumber}</div>
                        </div>  

                        <div style={{ flex: "2", textAlign: "center" }}>
                            <div style={{ fontSize: "16px",  color: "#555" }}>TAX INVOICE</div>
                          <div style={{ fontSize: "18px",marginTop: "5px", fontWeight: "800", textTransform: "uppercase", lineHeight: "1" }}>
                            {settings?.saleProfileData?.title || "COMPANY NAME"}
                          </div>
                        
                        </div>
                        
                        <div style={{ flex: "1", textAlign: "right",  }}>
                         <div style={{ display: "inline-block", textAlign: "right" }}>
                          <div className=" font-13"  style={{ borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, marginBottom: "5px" }}>
                            Invoice No.<span className="fw-bold"> {isViewData?.saleno}</span>
                          </div>
                          <div className="d-flex justify-content-end font-13">
                            {/* <span>DATE: {saleTime?.date}</span> */}
                            <span> DATE: {saleTime?.date}</span><span className="ms-3">TIME:{saleTime?.time}</span>
                          </div>
                        </div>
                        </div>
                      </div>
                      {globalData?.saleto &&(
                      <div  className="d-flex " style={{border:`1px solid ${selectedTheme?.templateTheme?.borderColor}`,}}>
                        <div style={{ flex: "1", padding: "5px", borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, }}>
                          <span className="fw-bold font-14">Customer Details :</span>
                          <div className="font-14 ">{isViewData?.saleto?.name}</div>
                          <div className="font-14">      {isViewData?.saleto?.addressline1 && `${isViewData?.saleto?.addressline1}, `}
                                                        {isViewData?.saleto?.addressline2 && `${isViewData?.saleto?.addressline2}, `}
                                                        {isViewData?.saleto?.district && `${isViewData?.saleto?.district}, `}{isViewData?.saleto?.pincode && ` - ${isViewData?.saleto?.pincode}`}</div>
                        </div>
                        {globalData?.saleto?.shippingAddress?.addressline1 &&
                                          globalData?.saleto?.shippingAddress?.addressline1 && (
                                    <div
                                      style={{
                                        flex: "1",
                                        padding: "5px",
                                        borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                      }}
                                    >
                                      <span className="fw-bold font-12">
                                        shipping  Details:
                                      </span>
                                      <div className="font-12">
                                        {" "}
                                        {globalData?.saleto?.shippingAddress?.addressline1 &&
                                          `${globalData?.saleto?.shippingAddress?.addressline1}, `}
                                        {globalData?.saleto?.shippingAddress?.addressline2 &&
                                          `${globalData?.saleto?.shippingAddress?.addressline2}, `}
                                        {globalData?.saleto?.shippingAddress?.district &&
                                          `${globalData?.saleto?.shippingAddress?.district}, `}
                                        {globalData?.saleto?.shippingAddress?.pincode &&
                                          ` - ${globalData?.saleto?.shippingAddress?.pincode}`}
                                      </div>
                                    </div>
                                    )}
                        <div style={{ width: "210px", padding: "5px",WebkitFontSmoothing: "antialiased", 
                      textRendering: "optimizeLegibility" }}>
                          <div className="font-14"><span className="fw-bold">Ph:</span> {" "} {isViewData?.saleto?.phone || ""}</div>
                          <div className=" font-14"> <span className="fw-bold">GSTIN:</span> {" "} {isViewData?.saleto?.gstnumber || ""}</div>
                        </div>
                      </div> 
                      )}
                                           <table width="100%" className="mt-0" style={{ borderCollapse: "collapse", }}>
                        <thead>
                          <tr className=" fw-bold"> 
                            <th
                            className="force-style"
                                                  style={{
                                                    width: "40px",
                                                  
                                                    "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                                                    "--th-color":
                                                      selectedTheme?.templateTheme?.foregroundColor,
                                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                  }}
                            //  style={{ border: "1px solid ",  padding: "5px", width: "40px" }}
                            > #</th>
                            <th 
                            className="force-style"
                                                  style={{                               
                                                    textAlign: "left",
                                                    "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                                                    "--th-color":
                                                      selectedTheme?.templateTheme?.foregroundColor,
                                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                  }}
                            // style={{ border: "1px solid ", padding: "5px", textAlign: "left" }}
                            >Item</th>
                           
                            <th 
                            className="force-style"
                                                  style={{
                                                    width: "80px",
                                                    textAlign: "right",
                                                    "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                                                    "--th-color":
                                                      selectedTheme?.templateTheme?.foregroundColor,
                                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                  }}
                            //  style={{ border: "1px solid ", padding: "5px", width: "80px" }}
                            >Rate</th>
                              <th 
                              className="force-style"
                                                  style={{
                                                    width: "60px",
                                                    textAlign: "center",
                                                    "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                                                    "--th-color":
                                                      selectedTheme?.templateTheme?.foregroundColor,
                                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                  }}
                              //  style={{ border: "1px solid ",  padding: "5px", width: "60px" }}
                              >Qty</th>
                               <th 
                            // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                            className="force-style"
                                                  style={{
                                                    width: "90px",
                                                    textAlign: "right",
                                                    "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                                                    "--th-color":
                                                      selectedTheme?.templateTheme?.foregroundColor,
                                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                  }}
                            > Taxable Val</th>
                         <th 
                            // style={{ border: "1px solid ", padding: "5px", width: "60px" }}
                            className="force-style"
                                                  style={{
                                                    width: "90px",
                                                    textAlign: "right",
                                                    "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                                                    "--th-color":
                                                      selectedTheme?.templateTheme?.foregroundColor,
                                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                  }}
                            > Tax Amt</th>
                        
                            <th 
                            // style={{ border: "1px solid ", padding: "5px", width: "100px" }}
                            className="force-style"
                                                  style={{
                                                    width: "100px",
                                                    textAlign: "right",
                                                    "--th-bg": selectedTheme?.templateTheme?.primaryColor,
                                                    "--th-color":
                                                      selectedTheme?.templateTheme?.foregroundColor,
                                                    "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                                                  }}
                            >
                              Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {globalData?.saleitems?.map((item, index) => (
                            <tr key={index} className="font-13  pt-1" style={{ height: "30px", }}>
                              <td   style={{  
                                borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, 

                                textAlign: "center" ,borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, }}>{index + 1}</td>
                              <td style={{  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,  }}>{item?.title}
                                 {item.hsnsac && (
                                          <div className="font-13">
                                            <span className="fw-medium">
                                              {" "}
                                              {item.imode === "SERVICE"
                                                ? "SAC:"
                                                : "HSN:"}
                                            </span>{" "}
                                            {item.hsnsac}
                                          </div>
                                        )}

                              </td>
                              <td style={{  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, textAlign: "right", paddingRight: "5px" }}>₹{item?.baseprice}</td>
                              <td style={{  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, textAlign: "center" }}>{item?.quantity} {
                                          (() => {
                                            const unitCode = item?.isSecondaryUnit
                                              ? (item?.unitConfig?.secondaryUnitCode ||"")
                                              : (item?.unitConfig?.primaryUnitCode || "");
                                            return unitCode||"" ;
                                          })()
                                        }</td>
                              <td style={{  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, textAlign: "right", paddingRight: "5px" }}>₹{item?.lineTotalBasePrice}</td>
                              <td style={{  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, textAlign: "right", paddingRight: "5px" }}>₹{item?.lineTotalTaxAmount}</td>
                              <td style={{  borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, textAlign: "right", paddingRight: "5px" }}>₹{item?.lineGrandTotal}</td>
                            </tr>
                          ))}
                      
                          {[...Array(Math.max(0, 5 - (globalData?.saleitems?.length || 0)))].map((_, i) => (
                            <tr key={`empty-${i}`} style={{ height: "50px" }}>
                              <td style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, borderLeft: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}></td>
                              <td style={{ borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`, }}></td>
                              <td style={{ borderRight:`1px solid ${selectedTheme?.templateTheme?.borderColor}`, }}></td>
                              <td style={{ borderRight:`1px solid ${selectedTheme?.templateTheme?.borderColor}`, }}></td>
                              <td style={{ borderRight:`1px solid ${selectedTheme?.templateTheme?.borderColor}`, }}></td>
                              <td style={{ borderRight:`1px solid ${selectedTheme?.templateTheme?.borderColor}`, }}></td>
                               <td style={{ borderRight:`1px solid ${selectedTheme?.templateTheme?.borderColor}`, }}></td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot style={{ borderTop: `2px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                        <tr className="font-13">                         
                          <td colSpan="4" style={{ padding: "5px", verticalAlign: "top", border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                            <span className="fw-bold">In Words:</span> {globalData?.amountinwords}
                          </td>

                          <td colSpan="3" style={{ padding: "0", border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                            <div className="d-flex justify-content-between p-1 px-2 "style={{ borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                              <span>Total</span>
                              <span className="">₹{globalData?.grandtotal}</span>
                            </div>
                            {!isInterState ? (
                              <>
                                <div className="d-flex justify-content-between p-1 px-2 " style={{ borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                                  <span>CGST</span>
                                  <span className="">₹{globalData?.cgstamount || 0}</span>
                                </div>
                                <div className="d-flex justify-content-between p-1 px-2">
                                  <span>SGST</span>
                                  <span className="">₹{globalData?.sgstamount || 0}</span>
                                </div>
                              </>
                            ) : (
                              <div className="d-flex justify-content-between p-1 px-2">
                                <span>IGST</span>
                                <span className="">₹{globalData?.igstamount || 0}</span>
                              </div>
                            )}
                          </td>
                        </tr>

                        {/* ROW 2: PAYMENT STATUS & SIGNATURE */}
                        <tr className="font-13">
                          {/* Left Side: Payment Methods (Cash/UPI/Card) */}
                          <td colSpan="4" style={{ padding: "0px", border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                          <div className="row g-2 m-0"> 
                            {globalData?.cashPaid > 0 && (
                              <div className="col-6 font-10 ps-1">
                                <span><b>₹{globalData.cashPaid}</b> Paid via Cash</span>
                              </div>
                            )}
                            {globalData?.upiPaid > 0 && (
                              <div className="col-6 font-10 ps-1">
                                <span><b>₹{globalData.upiPaid}</b> Paid via UPI</span>
                              </div>
                            )}
                            {globalData?.cardPaid > 0 && (
                              <div className="col-6 font-10 ps-1">
                                <span><b>₹{globalData.cardPaid}</b> Paid via Card</span>
                              </div>
                            )}
                            {globalData?.onlinePaid > 0 && (
                              <div className="col-6 font-10 ps-1">
                                <span><b>₹{globalData.onlinePaid}</b> Paid via Online</span>
                              </div>
                            )}
                          </div>
                        </td>

                          {/* Right Side Stack: Payment Summary */}
                          <td colSpan="3" style={{ padding: "0", border: `1px solid ${selectedTheme?.templateTheme?.borderColor}` }}>
                            <div className="d-flex justify-content-between p-1  px-2 border-bottom " style={{backgroundColor:`${selectedTheme?.templateTheme
                                            ?.primaryColor}`}}>
                              <span className="fw-bold pb-1" style={{ color: selectedTheme?.templateTheme?.foregroundColor}}>Amount Payable</span>
                              <span className="fw-bold pb-1 fw-bold " style={{ color: selectedTheme?.templateTheme?.foregroundColor}}>₹{globalData?.balanceDue || 0}</span>
                            </div>
                            <div className="d-flex justify-content-between p-1 px-2">
                              <span className="">Amount Paid</span>
                              <span className=" ">₹{parseFloat(actualPaidAmount || 0).toFixed(2)}</span>
                            </div>
                          </td>
                        </tr>
                      </tfoot>
                      </table>
                     
                    <div className="row mt-2">                                     
                                         <div className="col-4 p-2 pt-0  border-dark font-11">
                                              {storeSettings?.paymentSettings
                                                ?.bankDetails  && (
                                                <>
                                                  <strong>Bank Details:</strong>
                                                  <div className="d-flex font-11">
                                                    <span
                                                      style={{ width: "80px" }}
                                                    >
                                                      Name:
                                                    </span>
                                                    <strong>
                                                      {
                                                        storeSettings
                                                          ?.paymentSettings
                                                          ?.bankDetails
                                                          ?.beneficiaryName
                                                      }
                                                    </strong>
                                                  </div>
                                                  <div className="d-flex font-11">
                                                    <span
                                                      style={{ width: "80px" }}
                                                    >
                                                      Account #:
                                                    </span>
                                                    <strong>
                                                      {
                                                        storeSettings
                                                          ?.paymentSettings
                                                          ?.bankDetails
                                                          ?.accountNo
                                                      }
                                                    </strong>
                                                  </div>
                                                  <div className="d-flex font-11">
                                                    <span
                                                      style={{ width: "80px" }}
                                                    >
                                                      IFSC:
                                                    </span>
                                                    <strong>
                                                      {
                                                        storeSettings
                                                          ?.paymentSettings
                                                          ?.bankDetails?.ifsc
                                                      }
                                                    </strong>
                                                  </div>
                                                  <div className="mt-2 font-11">
                                                    <strong>
                                                      UPI ID:{" "}
                                                      {
                                                        storeSettings
                                                          ?.paymentSettings
                                                          ?.upiId
                                                      }
                                                    </strong>
                                                  </div>{" "}
                                                </>
                                              )}
                                            </div>
                                            {qrCodeDataUrl &&  (
                                              <div className="col-3 d-flex align-items-center justify-content-end">
                                                <img
                                                  src={qrCodeDataUrl}
                                                  alt="QR"
                                                  style={{
                                                    width: "100px",
                                                    height: "100px",
                                                  }}
                                                />
                                              </div>
                                            )}                                           
                                          
                                      <div className="col-5  ms-auto">
                                        <div className="text-end p-0 fw-bold font-12 mt-2 ">
                                          {globalData?.salefrom?.title}
                                        </div>
                                        <div>
                                          {storeSettings?.invoiceSettings
                                            ?.signature ? (
                                            <div className="text-end p-0 fw-bold pb-1">
                                              <img
                                                src={
                                                  uRLs.IMAGE_URL +
                                                  storeSettings?.invoiceSettings
                                                    ?.signature
                                                }
                                                width={100}
                                              />
                                            </div>
                                          ) : (
                                            <div className="p-0 pt-4">
                                              <hr
                                                className="m-1 ms-auto "
                                                style={{
                                                  border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                                  maxWidth: "120px",
                                                }}
                                              />
                                            </div>
                                          )}
                                          <div className="text-end p-0 font-12">
                                            Authorized Signatory
                                          </div>
                                        </div>
                                      </div>
                                                                             <div className="col-12">
                                      {globalData?.remark && (
                                        <table width="100%" className="mb-2">
                                          <tbody>
                                            <tr>
                                              <td width="100%">
                                                <div
                                                  className="font-12 fw-600 align-left text-black mb-1"             
                                                >
                                                  Remark
                                                </div>

                                                <div
                                                  className="font-12 p-0"
                                                  style={{                                             
                                                   
                                                    whiteSpace: "pre-wrap",
                                                    wordBreak: "break-word",
                                                    minHeight: "30px",
                                                  }}
                                                >
                                                  {capitalizeFirstLetter(globalData?.remark)}
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      )}      
                                      </div>     
                                      <div className="col-12 ">
                                        {terms?.length > 0 && (
                                          <table width="100%">
                                            <tbody>
                                              <tr>
                                                <td
                                                  style={{
                                                    padding: "0px",
                                                  }}
                                                  width="100%"
                                                >
                                                  <div
                                                    className="font-12 fw-600"
                                                    style={{
                                                      textAlign: "left",
                                                      color: "black",
                                                    }}
                                                  >
                                                    Terms & Conditions
                                                  </div>
                                                  <div className="terms-box font-12">
                                                    {terms}
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        )}
                                      </div>
                                    </div>
                      {storeSettings?.negobillBranding && (
                                                                <>
                                                              <div className="mt-5 font-13 d-flex justify-content-left ">
                                                                <span
                                                                >
                                                                  Powered By <span className="fw-bold">NegoBill.com</span>
                                                                </span>
                                                              </div>                                          
                                                            
                        </>)}
                    </div>
                  
                  </div>
                </div>
              </div>
            ) : selectedSize === "BILL" ? ( 
               <div className="tm_container">
                <div className="tm_invoice_wrap">
                  <div className="tm_invoice tm_style1 tm_type1">
                  
                  </div>
                </div>
              </div>
            ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>

      <div
        className="modal-footer d-block mt-2"
        style={{
          position: "sticky",
          bottom: -4,
          background: "#fff",
          zIndex: 10,
          borderTop: "1px solid #e0e0e0",
        }}
      >
        {payment && <div className="fw-600 mb-2 font-14">PAYMENT SUMMARY</div>}
        {payment && (
          <table
            className="items table-bordered mb-3"
            width="100%"
            cellPadding="4"
          >
            <tbody className="text-center">
              <tr>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor: isViewData.cashamount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                  }}
                  onClick={(e) => {
                    if (isViewData.cashamount > 0) {
                      cashRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.cashamount > 0
                        ? "badge rounded-pill bg-label-moon d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px", fontSize: "12px" }}
                  >
                    CASH
                    {isViewData?.cashamount > 0 && <ShowIcon/>}
                  </div>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  CARD
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  ONLINE
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                >
                  UPI
                </th>
                <th
                  style={{
                    textAlign: "center",
                    background: "#f3f3f3",
                    border: "0.5mm solid #e0e0e0",
                    cursor:
                      isViewData?.paylateramount > 0 ? "pointer" : "default",
                    padding: "2px 8px",
                    fontSize: "12px",
                  }}
                  onClick={(e) => {
                    if (isViewData?.paylateramount > 0) {
                      paylaterRef.current.openPopover(e);
                    }
                  }}
                >
                  <div
                    className={
                      isViewData?.paylateramount > 0
                        ? "badge rounded-pill bg-label-fire d-inline-flex align-items-center"
                        : "d-inline-flex align-items-center"
                    }
                    style={{ gap: "4px" }}
                  >
                    PAYLATER
                    {isViewData?.paylateramount > 0 && (
                      <ShowIcon iClass={"ms-1"} />
                    )}
                  </div>
                </th>
              </tr>
              <tr>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cashamount || 0) -
                      (isViewData?.cashchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.cardamount || 0) -
                      (isViewData?.cardchange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.onlineamount || 0) -
                      (isViewData?.onlinechange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.upiamount || 0) - (isViewData?.upichange || 0)
                  )}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    border: "0.5mm solid #e0e0e0",
                    fontSize: "12px",
                  }}
                  className="text-center"
                >
                  {formatCurrency2(
                    (isViewData?.paylateramount || 0) -
                      (isViewData?.paylaterchange || 0)
                  )}
                </td>
              </tr>
            </tbody>
            <CashButton
              ref={cashRef}
              trackId={isViewData?.boxCashInfo?.trackid}
              trackMode={isViewData?.boxCashInfo?.trackmode}
            />
            <PayLaterButton
              ref={paylaterRef}
              trackId={isViewData?.paylaterInfo?.trackid}
              customerId={isViewData?.paylaterInfo?.customerid}
              trackMode={isViewData?.paylaterInfo?.trackmode}
            />
          </table>
        )}
        {downloadbtn && (
          <div className="my-2 d-flex gap-2">
            <div className="btn-group text-right align-items-center">
              {print ? (
                <button
                  className="btn bg-label-animal btn-sm pb-0 font-12"
                  disabled
                >
                  <CircularProgress size={12} className="text-white" />
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handlePrint(data)}
                    className="btn bg-label-animal shadow-none btn-sm font-12"
                    id="printreceiptbtn"
                  >
                    <PrinterIcon iClass={"fs-12"}/> Print
                  </button>
                </>
              )}
            </div>

            {download ? (
              <button
                className="btn btn-warning btn-sm pb-0 text-right"
                disabled
              >
                <CircularProgress size={18} className="text-black" />
              </button>
            ) : (
              <button
                className="btn btn-warning btn-sm text-right"
                id="generatebillpdfbtn"
                onClick={() => handleDownload(data)}
              >
                <DownloadIcon iClass={"fs-15"}/>
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default InvoiceThumnail8;
